export enum EMissionBonusGroupKey {
  // L0 = "GR_CASH_5",
  L0 = 'entry_mission_bonus',
  // L1 = "GR_CASH_5",
  L1 = 'L1_bonus',
  L2 = 'L2_bonus',
  // L3 = 'manual_lootbox_bonus',
  L3 = 'L3_bonus',
  L4 = 'L4_bonus',
  L5 = 'L5_bonus',
}

export const MISSION_BONUS_GROUP_KEYS = Object.values(EMissionBonusGroupKey);

export const MISSION_LOTBOXES_GROUP_KEYS = [
  EMissionBonusGroupKey.L3,
  EMissionBonusGroupKey.L5,
];

export const MAP_BONUS_GROUP_KEY_TO_CHARACTER: Record<
  EMissionBonusGroupKey,
  number
> = {
  [EMissionBonusGroupKey.L0]: 0,
  [EMissionBonusGroupKey.L1]: 1,
  [EMissionBonusGroupKey.L2]: 2,
  [EMissionBonusGroupKey.L3]: 3,
  [EMissionBonusGroupKey.L4]: 4,
  [EMissionBonusGroupKey.L5]: 5,
};
